module.exports = __webpack_public_path__ + "static/media/29ADMSPC17.1194580e.jpg";